"use client";
/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useRef, useState } from "react";
import LinkButton from "../components/button";
import Image from "next/image";
import useIsMobile from "../hooks/useIsMobile";
import { configuration } from "../helpers/config";
import ExteriorViewer from "./ImageViewer/ExteriorViewer";
import Loader from "./Loader/Loader";
//import ScrollyVideoComponent from "./DesktopParallax/ScrollyVideo";
import ExteriorParallax from "./AndroidParallax/ExteriorParallax";
import { MediaPlayer, MediaProvider } from "@vidstack/react";
import dynamic from 'next/dynamic';
import Link from "next/link";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";

const ScrollyVideoComponent  = dynamic(() => import('./DesktopParallax/ScrollyVideo'), {
  ssr: false, // Prevents server-side rendering for faster response
  loading: () => <p>loading</p>
});

// component to render exterior 360 view of the car, uses iframe to render
export default function Exterior360({
  longDesc,
  shortDesc,
  extTitle,
  buttonText,
  imgUrl,
  buttonHref,
  html,
  imgSrc,
  imageStatic,
  hideCtaText,
  icon360,
  cta,
  modelName,
  iframeClass,
  exteriorImagesArr,
  colorsArr,
  exteriorViewData,
  parallaxImages,
  imgArrLength,
  configuratorData,
  variantsData,
  staticPage=false
}) {
  const mobile = useIsMobile();
  const containerRef = useRef(null);
  const videoRef = useRef(null);
   const [isLoading, setIsLoading] = useState(true);
    const [hideImage, setHideImage] = useState(false);
    const [isLoadingMobile, setIsLoadingMobile] = useState(true);
  const [containerHeight, setContainerHeight] = useState("100%");
  useEffect(() => {
    if (mobile && !/Android/i.test(navigator.userAgent)) {
      function getPosition(el) {
        if (el) {
          var rect = el.getBoundingClientRect();

          // Deal with browser quirks with page scroll
          var xScroll = window.scrollX || document.documentElement.scrollLeft;
          var yScroll = window.scrollY || document.documentElement.scrollTop;

          var xPos = rect.left + xScroll;
          var yPos = rect.top + yScroll;

          return {
            x: xPos,
            y: yPos,
          };
        }
      }
      const playbackConst = 500; // Adjust the constant as needed
      const update = () => {
        if (window.scrollY >= getPosition(containerRef.current)?.y - 100) {
          setContainerHeight(
            Math.floor(videoRef.current.duration) * playbackConst + "px"
          );
          videoRef.current.currentTime =
            parseFloat(
              (window.scrollY - getPosition(containerRef.current).y) /
                playbackConst
            ) + 1.2;
        } else {
          setContainerHeight("100%");
        }
      };
      window.addEventListener("scroll", update);

      return () => {
        window.removeEventListener("scroll", update);
      };
    }
  }, []);

  return (
    <div id="exterior" className="mt-10 container-fluid exterior360">
      <div className="container mx-auto exterior360__longdesc">
        <h5 className="text-center md:mb-[100px] max-w-[700px] leading-8 mx-auto ">
          {extTitle}
        </h5>
      </div>
      {imgUrl ? (
        <div className="exterior360__plunginHTML">
          <div className="hidden md:flex">
            {imageStatic ===true ? 
            <>
            {/* {isLoading && !hideImage && <Skeleton height={mobile ? 564 : 830} width={mobile ? 768 : 1928} />} */}
            {!hideImage && (
            <Image
              // src={!imageStatic ? configuration.IMG_URL + imgUrl : imgUrl}
              src={
                imageStatic
                  ? imgUrl
                    ? imgUrl
                    : ""
                  : ""
              }
              alt="exterior"
              width={mobile ? 768 : 1928}
              // height={mobile ? 920 : 1153}
              height={mobile ? 564 : 830}
              onError={() => setHideImage(true)}
              className={setIsLoading ? "hidden" : "block"}
              onLoad={() => setIsLoading(false)}
            />
            )}
            </>
            :
            <>
            {/* {isLoading && !hideImage && <Skeleton height={mobile ? 564 : 830} width={mobile ? 768 : 1928} />} */}
            {!hideImage && (
            <Image
              // src={!imageStatic ? configuration.IMG_URL + imgUrl : imgUrl}
              src={
                !imageStatic
                  ? imgUrl
                    ? `${configuration.IMG_URL}${imgUrl}`
                    : ""
                  : ""
              }
              alt="exterior"
              width={mobile ? 768 : 1928}
              // height={mobile ? 920 : 1153}
              height={mobile ? 564 : 830}
              onError={() => setHideImage(true)}
              className={setIsLoading ? "hidden" : "block"}
              onLoad={() => setIsLoading(false)}
            />
          )}
            </>
            }
          </div>

          <div className="flex w-full md:hidden">
          {/* {isLoading && !hideImage && <Skeleton height={mobile ? 564 : 830} width={mobile ? 768 : 1928} />} */}
          {!hideImage && (
            <Image
              src={
                !imageStatic
                  ? imgUrl
                    ? `${configuration.IMG_URL}${imgUrl}`
                    : ""
                  : ""
              }
              alt="exterior"
              width={mobile ? 768 : 1928}
              // height={mobile ? 920 : 1153}
              height={ mobile ? 564 : 830}
              onError={() => setHideImage(true)}
              className={setIsLoading ? "hidden" : "block"}
              onLoad={() => setIsLoading(false)}
              
            />
          )}
          </div>
          {!icon360 && (
            <div className="exterior360__icon--container">
             
              <img
                className="exterior360__icon"
                src={`${configuration.IMG_STATIC_URL}assets/images/cars/360-icon.png`}
                alt="360 Icon"
              />
            </div>
          )}
        </div>
      ) : (
        <></>
      )}
      {/* {
        (colorsArr?.length > 0 && exteriorViewData?.show_configurator) ?
        <ExteriorViewer colorsArr={colorsArr} /> : <></>
      } */}
      {/* <ExteriorParallax imgArr={exteriorImgArr} /> */}
      {exteriorViewData?.show_vedio &&
      configuration?.SHOW_PARALLAX === "true" ? (
        mobile && !/Android/i.test(navigator.userAgent) ? (
          <div
            className="relative w-full"
            ref={containerRef}
            style={{ height: containerHeight }}
          >
            <div className="top-[30px] mx-auto sticky h-screen">
              <div className="relative w-full h-full">
                <MediaPlayer
                  title="Sprite Fight"
                  ref={videoRef}
                  className="absolute top-[50%] left-[50%] w-full h-auto"
                  style={{ transform: "translate(-50%, -50%)" }}
                  playsInline
                  src={`${process.env.NEXT_PUBLIC_IMG_URL}${exteriorViewData?.video_mobile}`}
                >
                  <MediaProvider />
                </MediaPlayer>
              </div>
            </div>
          </div>
        ) : mobile && /Android/i.test(navigator.userAgent) ? ( //Specifically for android
          true ? (
            parallaxImages?.length == imgArrLength ? (
              <ExteriorParallax imgArr={parallaxImages} />
            ) : (
              <div className="relative h-screen">
                <Loader />
              </div>
            )
          ) : (
            <div
              className="relative w-full"
              ref={containerRef}
              style={{ height: containerHeight }}
            >
              <div className="top-[30px] mx-auto sticky h-screen">
                <div className="relative w-full h-full">
                  <MediaPlayer
                    title="Sprite Fight"
                    ref={videoRef}
                    className="absolute top-[50%] left-[50%] w-full h-auto"
                    style={{ transform: "translate(-50%, -50%)" }}
                    playsInline
                    src={`${process.env.NEXT_PUBLIC_IMG_URL}${exteriorViewData?.video_mobile}`}
                  >
                    <MediaProvider />
                  </MediaPlayer>
                </div>
              </div>
            </div>
          )
        ) : (
          <div style={{ height: "1000vh" }}>
            <ScrollyVideoComponent
              src={ exteriorViewData?.video_desktop? `${process.env.NEXT_PUBLIC_IMG_URL}${exteriorViewData?.video_desktop}` : "" }
            />
            {/* <ScrollyVideoComponent src={`${configuration.IMG_URL}${exteriorViewData?.video_desktop}`} /> */}
          </div>
        )
      ) : (
        <></>
      )}
      {/* {colorsArr?.length > 0 ? (
        <ExteriorViewer colorsArr = {colorsArr}/>
      ): html && exteriorViewData?.show_html ? (
        <div
          className="md:mt-[100px]"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      ) : (imgSrc && exteriorViewData?.show_images) ? (
        <div className="md:mt-[100px] mt-[50px]">
          <Image
            src={`${configuration.IMG_URL}${imgSrc}`}
            alt="interior"
            width={mobile ? 768 : 1928}
            // height={mobile ? 920 : 1153}
            height={mobile ? 564 : 830}
          />
        </div>
      ) : <></>} */}
      {(!staticPage && html && exteriorViewData?.show_html) || (staticPage && html) ? (
      <div
      className={`iframe-test ${iframeClass}`}
      dangerouslySetInnerHTML={{ __html: html }}
    /> 
      ) : imgSrc && exteriorViewData?.show_images ? (
        buttonHref ? (
  
          <Link 

            className="cursor-pointer" 

            href={buttonHref}

          >

            <div className={`md:mt-[100px] mt-[50px] ${buttonHref ? "cursor-pointer" : ""}`}>
            {/* {isLoading && !hideImage && <Skeleton height={mobile ? 564 : 830} width={mobile ? 768 : 1928} />} */}
            {!hideImage && (
          <Image
            // src={
            //   !imageStatic
            //     ? imgUrl
            //       ? `${configuration.IMG_URL}${imgUrl}`
            //       : ""
            //     : ""
            // }
            src={
              !imageStatic
                ? imgSrc
                  ? `${configuration.IMG_URL}${imgSrc}`
                  : ""
                : ""
            }
            alt="exterior"
            width={mobile ? 768 : 1928}
            // height={mobile ? 920 : 1153}
            height={mobile ? 564 : 830}
            onError={() => setHideImage(true)}
            className={setIsLoading ? "hidden" : "block"}
            onLoad={() => setIsLoading(false)}
          />
            )}
        </div>
        </Link>
      ) : (
        <div className="md:mt-[100px] mt-[50px]">
          {/* {isLoading && !hideImage && <Skeleton height={mobile ? 564 : 830} width={mobile ? 768 : 1928} />} */}
          {!hideImage && (
  
        <Image

          src={imgSrc ? `${configuration.IMG_URL}${imgSrc}` : ""}

          alt="exterior"

          width={mobile ? 768 : 1928}

          height={mobile ? 564 : 830}

          layout="responsive" // Automatically adjusts the height based on width

          objectFit="contain" // Maintains aspect ratio without stretching
          onError={() => setHideImage(true)}
          className={isLoading ? "hidden" : "block"}
          onLoad={() => setIsLoading(false)}
        />
          )}

      </div>

    )

  )

     : (
      exteriorViewData?.show_configurator && colorsArr?.length > 0 && (
          <ExteriorViewer
            configuratorData={configuratorData}
            colorsArr={colorsArr}
            variantsData={variantsData}
          />
        )
      )}

<div className="exterior360__others">
  <div className="container mx-auto exterior360__others--container">
    <div className="exterior360__subsection">
      {longDesc && (
        <h5 className="md:pr-[30px] lg:pr-[30px]">
          {longDesc} {modelName ? `| ${modelName}` : ''}
        </h5>
      )}

            <div className="exterior360__rightbox pr-[60px] lg:pr-[75px]">
              <p>{shortDesc}</p>
              {!hideCtaText && (
                <LinkButton
                  Id={
                    "ModelExterior" +
                    (exteriorViewData?.title)?.replace(/\s+/g, "")
                  }
                  type={"button_dark_arrow"}
                  buttontext={buttonText}
                  href={buttonHref}
                  classname="button_dark_arrow"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
